import Axios from "axios";
import KnockOut from "knockout";
import KnockOutMapping from "knockout-mapping";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class CartDetailViewModel {
    constructor() {
        let self: any = this;

        self.isDataFetched = KnockOut.observable(false);
        self.isExpressCart = KnockOut.observable(true);
        self.isExpressProduct = KnockOut.observable(false);

        self.shippingDestinations = KnockOut.observableArray();
        self.selectedShippingDestination = KnockOut.observable();
        self.minimumOrderTotal = KnockOut.observable();
        self.freeShippingTableTotal = KnockOut.observable();
        self.firstShippingCostThreshold = KnockOut.observable();
        self.secondShippingCostThreshold = KnockOut.observable();
        self.businessDiscountNotes1 = KnockOut.observable();
        self.businessDiscountNotes2 = KnockOut.observable();

        self.update = function (cartInfo: any) {
            KnockOutMapping.fromJS(cartInfo, {}, self);
            (<any>window).App.viewModels.cartPreview.update(cartInfo);

            self.isExpressCart(cartInfo.cartRows.every(function (cartRow) { return cartRow.is24HoursDelivery }));
            self.isExpressProduct(cartInfo.cartRows.some(function (cartRow) { return cartRow.is24HoursDelivery }));
        };

        self.addQuantity = function (cartRow: any) {
            if (!isNaN(parseInt(cartRow.quantity(), 10))) {
                cartRow.quantity(parseInt(cartRow.quantity(), 10) + 1);
            } else {
                cartRow.quantity(1);
            }

            if (cartRow.quantity() > 20) {
                cartRow.quantity(20);
            }
        };

        self.removeQuantity = function (cartRow: any) {
            if (!isNaN(parseInt(cartRow.quantity(), 10))) {
                cartRow.quantity(parseInt(cartRow.quantity(), 10) - 1);
            } else {
                cartRow.quantity(1);
            }

            if (cartRow.quantity() < 1) {
                cartRow.quantity(1);
            }
        };

        self.updateQuantity = async function (cartRow: any) {
            var $context = $("#Page");

            FormHelper.resetValidation($context);
            FormHelper.disableControls($context);
            $(".validation").hide();

            try {
                let cartDetail = (await Axios.post((<any>window).App.routes.Cart_UpdateQuantity, { cartRowCode: cartRow.cartRowCode(), quantity: cartRow.quantity() }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

                self.update(cartDetail.cartInfo);
            } catch (error) {
                if (error.response.status === 400) {
                    FormHelper.setValidation($context, error.response.data);
                    $(".validation").show();
                }
            }

            FormHelper.enableControls($context);
        };

        self.remove = async function (cartRow: any) {
            var $context = $("#Page");

            FormHelper.resetValidation($context);
            FormHelper.disableControls($context);
            $(".validation").hide();

            try {
                let cartDetail = (await Axios.post((<any>window).App.routes.Cart_RemoveProduct, { cartRowCode: cartRow.cartRowCode() }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

                GTagHelper.sendEvent("remove_from_cart", {
                    currency: "EUR",
                    value: parseFloat(cartRow.rowPrice().replace(/\./g, "").replace(",", ".")),
                    items: [
                        {
                            item_id: cartRow.productCode(),
                            item_name: cartRow.productName(),
                            affiliation: "IloveOstrica",
                            item_category: cartRow.categoryName(),
                            price: parseFloat(cartRow.unitPrice().replace(/\./g, "").replace(",", ".")),
                            quantity: cartRow.quantity()
                        }
                    ]
                });

                self.update(cartDetail.cartInfo);
            } catch (error) {
                if (error.response.status === 400) {
                    FormHelper.setValidation($context, error.response.data);
                    $(".validation").show();
                }
            }

            FormHelper.enableControls($context);
        };

        self.setCouponCode = async function () {
            let $context = $("#Page");

            FormHelper.resetValidation($context);
            FormHelper.disableControls($context);
            $(".validation").hide();

            try {
                let cartDetail = (await Axios.post((<any>window).App.routes.Cart_SetCouponCode, { couponCode: self.couponCode() }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

                self.update(cartDetail.cartInfo);
            } catch (error) {
                if (error.response.status === 400) {
                    FormHelper.setValidation($context, error.response.data);
                    $(".validation").show();
                }
            }

            FormHelper.enableControls($context);
        }

        self.checkout = async function (cartRow: any) {
            var $context = $("#Page");
            var track_event = { "data": { "items": [] } };

            for (var i = 0; i < cartRow.cartRows().length; i++) {
                var cartRowInfo = {
                    "ProductName": cartRow.cartRows()[i].productName(),
                    "ProductImageUrl": "/it/media/product/images/150-150-fix/" + cartRow.cartRows()[i].productImageCode(),
                    "Quantity": cartRow.cartRows()[i].quantity(),
                    "VariantCode": cartRow.cartRows()[i].variantCode(),
                    "VariantName": cartRow.cartRows()[i].variantDescription(),
                    "UnitPrice": cartRow.cartRows()[i].unitPrice(),
                    "UnitPriceNoVAT": cartRow.cartRows()[i].unitPriceNoVAT(),
                    "TotalPrice": cartRow.cartRows()[i].rowPrice()
                };
                track_event.data.items.push(cartRowInfo);
            }

            FormHelper.resetValidation($context);
            FormHelper.disableControls($context);
            $(".validation").hide();

            try {
                await Axios.post((<any>window).App.routes.Cart_SetCouponCode, { couponCode: self.couponCode() }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

                if ((<any>window).fbq) {
                    (<any>window).fbq("track", "InitiateCheckout");
                }

                if ((<any>window).sendinblue) {
                    (<any>window).sendinblue.track("Click_Carrello_Completa_Ordine", {}, track_event);
                }

                window.location = (<any>window).App.routes.Checkout_Summary;
            } catch (error) {
                if (error.response.status === 400) {
                    FormHelper.setValidation($context, error.response.data);
                    $(".validation").show();
                }
            }

            FormHelper.enableControls($context);
        };

        async function init() {
            let cartinfo = (await Axios.post((<any>window).App.routes.Cart_GetCartInfo, {})).data;
            KnockOutMapping.fromJS(cartinfo, {}, self);
            self.isDataFetched(true);
            self.businessDiscountNotes1(cartinfo.businessDiscountNotes1);
            self.businessDiscountNotes2(cartinfo.businessDiscountNotes2);

            self.isExpressCart(cartinfo.cartRows.every(function (cartRow) { return cartRow.is24HoursDelivery }));
            self.isExpressProduct(cartinfo.cartRows.some(function (cartRow) { return cartRow.is24HoursDelivery }));

            var itemList = [];
            for (var i in cartinfo.cartRows) {
                itemList.push({
                    item_id: cartinfo.cartRows[i].productCode,
                    item_name: cartinfo.cartRows[i].productName,
                    affiliation: "IloveOstrica",
                    item_category: cartinfo.cartRows[i].categoryName,
                    price: parseFloat(cartinfo.cartRows[i].unitPrice.replace(/\./g, "").replace(",", ".")),
                    quantity: cartinfo.cartRows[i].quantity
                });
            }

            if (cartinfo.cartQuantity !== 0) {
                GTagHelper.sendEvent("view_cart", {
                    currency: "EUR",
                    value: parseFloat(cartinfo.cartTotalWithCosts.replace(/\./g, "").replace(",", ".")),
                    items: itemList
                });
            }

            const result = (await Axios.post((<any>window).App.routes.Cart_GetShippingDestinations, {})).data;
            self.shippingDestinations(result.shippingDestinations);
            self.minimumOrderTotal(result.minimumOrderTotal);
            self.freeShippingTableTotal(result.freeShippingTotal);
            self.firstShippingCostThreshold(result.firstShippingCostThreshold);
            self.secondShippingCostThreshold(result.secondShippingCostThreshold);
        }

        init();
    }
}